"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var panel_1 = require("../../../../components/pricing/layout/panel/panel");

var hyperlink_field_1 = require("../../../../components/pricing/text/hyperlink-field/hyperlink-field");

var output_field_1 = require("../../../../components/pricing/text/output-field/output-field");

var constants_1 = require("../../../../theming/pricing-system/constants");

var theme_1 = require("../../../../theming/theme");

var api_helper_1 = require("../../../../utils/api.helper");

var money_formatter_1 = require("../../../../utils/formatters/money-formatter");

var fullWidthStyle = {
  width: '98%'
};
var panelViewStyle = {
  justifyContent: 'space-between'
};
var priceFieldViewStyle = {
  borderColor: theme_1.PurpleScale.darkest,
  borderRadius: 4,
  borderStyle: 'solid',
  borderWidth: 2,
  flexBasis: '10rem',
  marginLeft: 'auto',
  marginRight: 'auto',
  padding: '.4em'
};

var PriceLookupResultsPanel = function (_super) {
  __extends(PriceLookupResultsPanel, _super);

  function PriceLookupResultsPanel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  PriceLookupResultsPanel.prototype.render = function () {
    return react_1.default.createElement(panel_1.Panel, {
      heading: constants_1.PriceLookupResultsPanelContent.heading,
      viewStyle: panelViewStyle
    }, this.renderPriceField(), this.renderTransactionIdField());
  };

  PriceLookupResultsPanel.prototype.componentDidUpdate = function () {
    if (!this.props.priceLookupResult) {
      return;
    }

    if (this.props.waitForDetails) {
      this.props.waitForDetails();
    }
  };

  PriceLookupResultsPanel.prototype.renderPriceField = function () {
    var lookupResult = this.props.priceLookupResult;
    var isPlaceholder = this.props.isPriceLookupInProgress || !lookupResult;
    var allowWrap = isPlaceholder;
    return react_1.default.createElement(output_field_1.OutputField, {
      allowWrap: allowWrap,
      isAnimated: true,
      isImportant: !isPlaceholder,
      isPlaceholder: isPlaceholder,
      label: "",
      isCentered: true,
      value: this.priceFieldValue,
      viewStyle: priceFieldViewStyle
    });
  };

  Object.defineProperty(PriceLookupResultsPanel.prototype, "priceFieldValue", {
    get: function get() {
      if (this.props.isPriceLookupInProgress) {
        return constants_1.PriceLookupResultsPanelContent.calculating;
      }

      var lookupResult = this.props.priceLookupResult;
      return lookupResult ? money_formatter_1.MoneyFormatter.format(lookupResult.priceInDollars) : constants_1.PriceLookupResultsPanelContent.specifyAllRequiredInformation;
    },
    enumerable: true,
    configurable: true
  });

  PriceLookupResultsPanel.prototype.renderTransactionIdField = function () {
    var lookupResult = this.props.priceLookupResult;

    if (!this.props.showTransactionDetails || !lookupResult) {
      return null;
    }

    var transactionId = lookupResult.transactionId;

    if (this.props.isWaitingForTransactionDetails) {
      return this.renderTransactionIdOutputField(transactionId);
    }

    return this.renderTransactionIdHyperLinkField(transactionId);
  };

  PriceLookupResultsPanel.prototype.renderTransactionIdOutputField = function (transactionId) {
    return react_1.default.createElement(output_field_1.OutputField, {
      viewStyle: fullWidthStyle,
      label: constants_1.PriceLookupResultsPanelContent.transactionIdLabel,
      value: transactionId
    });
  };

  PriceLookupResultsPanel.prototype.renderTransactionIdHyperLinkField = function (transactionId) {
    var url = '';
    var transactionDetailsApi = this.props.transactionDetailsApi;

    if (transactionDetailsApi) {
      url = api_helper_1.buildUrl(transactionDetailsApi, 'detailsUrl', {
        ':transactionId': transactionId
      });
    }

    return react_1.default.createElement(hyperlink_field_1.HyperlinkField, {
      viewStyle: fullWidthStyle,
      label: constants_1.PriceLookupResultsPanelContent.transactionIdLabel,
      text: transactionId,
      url: url
    });
  };

  return PriceLookupResultsPanel;
}(react_1.default.Component);

exports.PriceLookupResultsPanel = PriceLookupResultsPanel;